// ==============================|| OVERRIDES - CARD (DASHBOARD VARIANT) ||============================== //

export default function Card(theme) {
  return {
    MuiCard: {
      variants: [
        {
          // Landing page cards
          props: { variant: 'landing-card' },
          style: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            minHeight: '190px',
            borderRadius: '16px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            transition: 'all 0.3s ease',
            backgroundColor: '#f5f3f7',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
            }
          }
        },
        {
          // Dashboard card variant - styled cards with icon support
          props: { variant: 'dashboard' },
          style: {
            cursor: 'pointer',
            border: '1px solid',
            borderColor: theme.palette.divider,
            backgroundColor: theme.palette.background.paper,
            borderRadius: '12px',
            boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.08)',
            transition: 'all 0.3s ease-in-out',
            minHeight: '140px',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: '#f9f5ff',
              opacity: 0,
              transition: 'opacity 0.3s ease-in-out',
              pointerEvents: 'none'
            },
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: '0 4px 20px 0 rgba(103, 58, 183, 0.25)',
              borderWidth: '2px',
              borderColor: 'rgba(103, 58, 183, 0.4)',
              '&::before': {
                opacity: 1
              }
            },
            // Auto-style CardContent inside dashboard cards
            '& .MuiCardContent-root': {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              height: '100%',
              paddingTop: theme.spacing(2.5),
              paddingBottom: theme.spacing(2.5),
              paddingLeft: theme.spacing(1.5),
              paddingRight: theme.spacing(1.5),
              position: 'relative',
              zIndex: 1,
              '&:last-child': {
                paddingBottom: theme.spacing(2.5)
              }
            },
            // Style for icon wrapper (use className="dashboard-icon")
            '& .dashboard-icon': {
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#ede7f6',
              marginBottom: theme.spacing(1),
              transition: 'background-color 0.3s ease-in-out',
              '& svg': {
                fontSize: '2rem',
                color: '#673ab7'
              }
            },
            '&:hover .dashboard-icon': {
              backgroundColor: '#d1c4e9'
            },
            // Style for title text
            '& .dashboard-title': {
              color: theme.palette.text.primary,
              fontWeight: 600,
              fontSize: '1rem',
              lineHeight: 1.4,
              marginTop: theme.spacing(0.5)
            }
          }
        },
        {
          // Selection card variant - for forms, templates, etc.
          props: { variant: 'selection-card' },
          style: {
            cursor: 'pointer',
            backgroundColor: '#fff',
            borderRadius: '12px',
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
            transition: 'all 0.3s ease',
            overflow: 'hidden',
            position: 'relative',
            border: '1px solid rgba(0, 0, 0, 0.08)',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              borderRadius: '12px 12px 0 0'
            },
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: '0 8px 24px rgba(102, 126, 234, 0.2)',
              borderColor: 'rgba(102, 126, 234, 0.3)'
            },
            '& .MuiCardContent-root': {
              padding: '24px 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              minHeight: '80px',
              '&:last-child': {
                paddingBottom: '24px'
              }
            },
            '& .selection-card-title': {
              fontSize: '1rem',
              fontWeight: 600,
              color: '#1a1a1a',
              textAlign: 'left',
              flex: 1,
              paddingRight: '16px'
            },
            '& .selection-card-arrow': {
              color: '#667eea',
              fontSize: '1.5rem',
              flexShrink: 0
            }
          }
        }
      ],
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 2px 14px 0 rgb(32 40 45 / 8%)'
        }
      }
    }
  };
}
